import { PageHeader } from "@shared/components/PageHeader";
import {
  IntegrationCardGrid,
  IntegrationCardConfig,
} from "@features/ix/shared/IntegrationCardGrid";
import React from "react";
const PAYMENT_CARDS: IntegrationCardConfig[] = [
  {
    title: "US Payment",
    subtitle: "ACH Processor",
    description:
      "Domestic ACH and bank transfer rails for low-cost utility bill collection.",
    status: "connect",
    comingSoon: false,
    connectPath: "/payments/uspayment/connect",
    configurePath: "/payments/uspayment/configure",
    detailsPath: "/payments/uspayment/details/1",
  },
];

const PaymentLanding = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Payments"
        subtitle="Configure payment providers for collections, settlements, refunds, and digital billing experiences."
      />
      <IntegrationCardGrid cards={PAYMENT_CARDS} />
    </div>
  );
};

export default PaymentLanding;
